import "./App.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { lazy, Suspense } from "react";

import Header from "./Utils/Header/Header";
import Loader from "./Utils/Loader/Loader";
import AbstractForm from "./Abstract/AbstractForm";
// import Scientific from "./Scientific/Scientific";
import Travels from "./Travels/Travels";

const Home = lazy(() => import(/* webpackChunkName: "Home" */ "./Home/Home"));

const Committee = lazy(() => import(/* webpackChunkName: "Home" */ "./Committee/Committee"));

const Registration = lazy(() => import(/* webpackChunkName: "Home" */ "./Registration/Registration"));
const NursingSymposiumForm = lazy(
  () => import(/* webpackChunkName: "Home" */ "./RegistrationForm/NursingSymposiumForm")
);

const About = lazy(() => import(/* webpackChunkName: "About" */ "./About/About"));

const Events = lazy(() => import(/* webpackChunkName: "Events" */ "./Events/Events"));

const EventDetails = lazy(() => import(/* webpackChunkName: "Events" */ "./Events/EventDetails"));

const RegistrationForm = lazy(() => import(/* webpackChunkName: "Events" */ "./RegistrationForm/RegistrationForm"));

const FacultyReg = lazy(() => import(/* webpackChunkName: "Events" */ "./FacultyRegistration/FacultyReg"));

const Faculty = lazy(() => import(/* webpackChunkName: "Events" */ "./Faculty/Faculty"));

const FacultyDetail = lazy(() => import(/* webpackChunkName: "Events" */ "./Faculty/Facultydetail"));

const Research = lazy(() => import(/* webpackChunkName: "Events" */ "./Research/Research"));

const Cases = lazy(() => import(/* webpackChunkName: "Events" */ "./Cases/Cases"));

const CasesDetail = lazy(() => import(/* webpackChunkName: "Events" */ "./Cases/CasesDetail"));

const Gallery = lazy(() => import(/* webpackChunkName: "Events" */ "./Gallery/Gallery"));

const Notices = lazy(() => import(/* webpackChunkName: "Events" */ "./Notices/Notices"));

const Policy = lazy(() => import(/* webpackChunkName: "Policy" */ "./Policy/Policy"));

const Contact = lazy(() => import(/* webpackChunkName: "Contact" */ "./Contact/Contact"));

const ScientificProgram = lazy(
  () => import(/* webpackChunkName: "ScientificProgram" */ "./ScientificProgram/ScientificProgram")
);

const theme = createTheme({
  palette: {
    primary: {
      main: "#082e56",
    },
    secondary: {
      main: "#808080",
    },
  },
});

const SuspenseLayout = () => (
  <>
    <Header />

    <Suspense
      fallback={
        <div className="loader-container">
          <Loader />
        </div>
      }>
      <Outlet />
    </Suspense>
  </>
);
function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route element={<SuspenseLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/committee" element={<Committee type="organizing-committee" />} />
            <Route path="/registration" element={<Registration />} />
            <Route path="/about" element={<About />} />
            <Route exact path="/events" element={<Events />} />
            <Route path="/event-details/:slug" element={<EventDetails />} />

            {/* <Route path="/event/:slug/register" element={<RegistrationForm />} />
            <Route path="/event/:slug/nursing-register" element={<NursingSymposiumForm />} /> */}

            <Route path="/event/:slug/abstract" element={<AbstractForm />} />
            <Route path="/event/:slug/scientific-program" element={<ScientificProgram />} />
            <Route path="/event/:slug/faculty-register" element={<FacultyReg />} />

            <Route path="/event/:slug/travel-and-accommodation" element={<Travels />} />

            <Route path="/faculty" element={<Faculty />} />
            <Route path="/faculty-details" element={<FacultyDetail />} />
            <Route path="/research" element={<Research />} />
            <Route path="/cases" element={<Cases />} />
            <Route path="/cases-details" element={<CasesDetail />} />

            <Route path="/photo-gallery" element={<Gallery />} />
            <Route path="/notices" element={<Notices />} />
            <Route path="/policy/:name" element={<Policy />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Home />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
